/**
 * Created by neo on 05.03.17.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Flight from '../../../Store/Flight';
import { Row, Col, Input, Button, FormGroup, Label, Card, CardBody } from 'reactstrap';
import { translate  } from 'react-i18next';
import FlightBookingRequest from '../../../Store/Booking/FlightBookingRequest';
import PricePreview from './PricePreview';
import AircraftSelect from './AircraftSelect';
import { Link } from 'react-router';
import Settings from '../../../Store/Settings';
import DatePicker from '../../../FlightOffer/View/Booking/DatePicker';
import moment from 'moment-timezone';

const _ = require('lodash');

type Props = {
  flight: Flight,
  booking: FlightBookingRequest,
  onBook: (bookingRequest: FlightBookingRequest) => void,
}

@observer
export class Booking extends Component {

  props: Props;

  constructor(props: Props) {
    super(props);
  }

  selectPassengerCount(passengerCount: number) {
    this.props.booking.setPassengerCount(passengerCount);
    this.props.booking.applyDiscounts();
  }

  generateOptions() {
    const options = [];
    for (let i = 1; i <= this.props.booking.maxPassengers; i++) {
      options.push((
        <option key={i} value={i}>{`${i}`}</option>
      ));
    }

    return options;
  }

  handleBooking = () => {
    if (this.props.onBook) {
      this.props.onBook(this.props.booking);
    }
  };

  render() {
    const { props: { booking, t, fullscreen } } = this;

    return (
      <Row className='booking-panel'>
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col className='mb-3'>
                  <div className='airplane-picker separator'>
                    <FormGroup className='mb-4'>
                      <h2>{t('Book a Flight')}</h2>
                      <AircraftSelect flightAircraft={booking.flight.aircraft_offer} />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup className='mb-4'>
                    <Label>2. {t('Datum')}</Label>
                    <Input value={moment(booking.flight.start_time).format('l LT')}></Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>3. {t('Anzahl Passagiere')}</Label>
                    <Input
                      type='select'
                      bsSize='sm'
                      value={booking.passengerCount}
                      onChange={e => this.selectPassengerCount(Number(e.target.value))}
                    >
                      {this.generateOptions()}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <PricePreview booking={booking} onChanged={this.handleTimeRangeChanged} />
                </Col>
              </Row>
              <Row>
                <Col className='d-flex justify-content-center align-items-center'>
                <Button
                      color='primary'
                      size='lg'
                      block
                      onClick={this.handleBooking}
                    >
                      {t('Buchen')}
                    </Button>
                </Col>
              </Row>
              <br/>
              {
                Settings.settings.has('voucher_template_file_id') && Settings.settings.get('voucher_template_file_id') > 0 &&
                <Row>
                  <Col>
                    <div className='d-flex justify-content-center align-items-center'>
                      <Link
                        className='btn btn-lg btn-secondary p-3'
                        to={`/voucher/offer/${booking.flightOffer.id}?aircraft=${booking.aircraft.id}&exclusive=${booking.is_exclusive}&passengers=${booking.passengerCount}`}
                      >
                        {t('Buy as a gift certificate')}
                      </Link>
                    </div>
                  </Col>
                </Row>
              }
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default translate ()(Booking);



// WEBPACK FOOTER //
// ./src/App/Flight/View/Booking/index.js